import React from 'react';
import ReactModal from 'react-modal';
import { X } from 'lucide-react';

ReactModal.setAppElement('#root');

export function ModalRemoveDocReact({ isOpen, onRequestClose, children }) {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="modal__overlay"
      className="modal__content"
    >
      <div className='modal__close'>
        <X onClick={onRequestClose} size={18} color='#686A76'/>
      </div>
      {children}
    </ReactModal>
  );
}
